import { soundToPlay } from '../../mechanics/sounds/sound'
import { useCallback, useState } from 'react'
import { sceneSlice } from '../../store/reducers/SceneReducer'
import { useAppDispatch, useAppSelector } from '../../store/store'
import { initPotion, Potion } from '../../mechanics/items/Potion'
import { Item } from '../../mechanics/items/Item'
import BaseButton from '../ui/BaseButton'
import "./Shop.scss"
import shopkeeper from "../../assets/img/characters_icons/npc/shopkeeper.png"
import shopkeeperWebp from "../../assets/img/characters_icons/npc/shopkeeper.webp"
import Inventory from "../Inventory/Inventory";
import { userSlice } from '../../store/reducers/userReducer'
import ShopItem from './ShopItem'
import ImgWithFallback from '../ui/ImgWithFallback'

const Shop = () => {
    const dispatch = useAppDispatch()
    const { setScene } = sceneSlice.actions
    const characterInventory = useAppSelector(state => state.userReducer.character.getInventory())
    const { setInventoryLength, setIsBuyOrSellItem } = userSlice.actions
    const mainCharacter = useAppSelector(state => state.userReducer.character)

    const healingPotion = new Potion(initPotion)

    const shopItems: Item[] = Array(25).fill(healingPotion)

    const backClick = () => {
        dispatch(setScene("main"))
    }

    const itemClick = useCallback((index: number) => {
        if (mainCharacter.getGold() >= shopItems[index].getCost()) {
            characterInventory.pushInInventory(shopItems[index].getClone())
            mainCharacter.setGold(mainCharacter.getGold() - shopItems[index].getCost())
            dispatch(setInventoryLength())
            dispatch(setIsBuyOrSellItem())
            soundToPlay("coin")
        }
    }, [])

    return (
        <div className='shop'>
            <h1 className='shop__title'>Shop</h1>
            <div className="shop__modal">
                <div className='shop__modal-column'>
                    <div className="shop__container">
                        <div className='shop__container-header'>
                            <ImgWithFallback
                                src={shopkeeperWebp}
                                fallbackSrc={shopkeeper} />
                            <h2 className="shop__container-title">Shopkeeper</h2>
                        </div>
                        <div className="shop__body">
                            <ul className='shop__body-items'>
                                {shopItems.map((item, i) => {
                                    return (
                                        <ShopItem key={crypto.randomUUID()} itemClick={() => itemClick(i)} item={item} />
                                    )
                                })}
                            </ul>
                        </div>
                        <div className="shop__container-footer"></div>
                    </div>
                </div>
                <div className='shop__modal-column'>
                    <Inventory isOpenInShop={true} />
                </div>
            </div>
            <BaseButton className="shop__btn" name="Back" onClick={backClick} />
        </div>
    );
}

export default Shop;